import { BasketItem } from '../../../store/slices/basketSlice';

const BASKET_STORAGE_KEY = 'basket';

const isBrowser = typeof window !== 'undefined';

export const getStoredBasket = (): BasketItem[] => {
  if (!isBrowser) {
    return [];
  }

  try {
    const basket = localStorage.getItem(BASKET_STORAGE_KEY);
    if (!basket) {
      return [];
    }

    const parsedBasket = JSON.parse(basket);

    if (!Array.isArray(parsedBasket)) {
      return [];
    }

    return parsedBasket.filter(
      item =>
        item &&
        typeof item === 'object' &&
        typeof item.id === 'number' &&
        typeof item.quantity === 'number' &&
        item.quantity > 0
    ) as BasketItem[];
  } catch {
    return [];
  }
};

export const saveStoredBasket = (basket: BasketItem[]) => {
  if (!isBrowser) {
    return;
  }

  localStorage.setItem(BASKET_STORAGE_KEY, JSON.stringify(basket));
};
